import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface CryptoPriceData {
  usd: number;
  usd_24h_change: number;
  usd_market_cap: number;
  usd_24h_vol: number;
}

export const useCryptoPrice = (cryptoId: string = 'bitcoin') => {
  return useQuery({
    queryKey: ['crypto-price', cryptoId],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('fetch-crypto-price', {
        body: { cryptoId }
      });

      if (error) throw error;
      
      return data[cryptoId] as CryptoPriceData;
    },
    refetchInterval: 30000, // Refetch every 30 seconds
  });
};
